import request from "@utils/request";

/**
 * 上传图片
 */
export function UPLOAD_IMG(data) {
  return request.post('upload/image',data);
}